export default __webpack_public_path__ + "assets/765110af50a63913e48d7f1657e0fefd.svg";